module.exports = __webpack_public_path__ + "img/update3.5_image02.9389c656.png";